/**
 * @generated SignedSource<<44e0daf13ce03c0abe277a696320d679>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapFilter_filter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapFilterTaxonomy_filter"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapFilterElement_filter"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapFilterUser_filter"
    }
  ],
  "type": "MapFilterBase",
  "abstractKey": "__isMapFilterBase"
};

node.hash = "3603a19fafc74fcec6498aacb662c1ba";

module.exports = node;
